module.exports = global["$"] = require("-!/Users/adityatiwari/plenty/27000/50/fussballfabrikVuePlugin/node_modules/expose-loader/index.js?jQuery!./jquery.js");